module.exports = __webpack_public_path__ + "media/images/omotenashi_symbolic-38aeeeed35fb09150ca81e4ff2631dba.jpg";